<template>
  <div>
    <div class="modal-area">
      <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10 }" :maxlength="100" placeholder="100字以内" v-model="content" style="margin-bottom: 24px;"></el-input>
    </div>
    <div class="customize-footer" style="text-align: center">
      <el-button @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '../../api/api';
import { addUserLogList } from '../../api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      content: '',
      submitLoading: false,
      id: this.value.id
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    submit() {
      if(!this.content) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '内容不能为空',
          type: 'warning'
        })
        return;
      }
      let param = {
        'id': this.id,
        'content': this.content
      }
      postFormData(addUserLogList, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm');
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  }
}
</script>

<style>

</style>
